/**
 * Semnalul „s-a întâmplat ceva în firmă”: clopoțelul îl dă la fiecare notificare
 * venită pe flux, iar ecranele cu cifre (panoul de control) se reîmprospătează.
 */
export const LIVE_EVENT = 'procumi:live';

export const announceLive = (): void => {
  window.dispatchEvent(new CustomEvent(LIVE_EVENT));
};
